module.exports = __webpack_public_path__ + "static/media/0001.ab66863b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/Anodized/0001.png
// module id = 751
// module chunks = 0